<template>
  <CRUDDialog ref="crudDialog" :canSave="false"
   :baseCrudKey="baseCrudKey" dialogDynamicWidth="40vw">
    <template v-slot:[`editedItem`]="{}">
      <v-row>
        <v-col cols="6">
          <v-btn class="input-text-size" text color="blue darken-1"
           @click="onCreteOmit">New Record</v-btn>
        </v-col>
        <v-col cols="6">
          <h4>Create a {{ selectedRowData.taxYear }} tax record from scratch</h4>
        </v-col>
        <v-col cols="6">
          <v-btn class="input-text-size" text color="blue darken-1"
           @click="onClick('curTaxYear')">
            Copy to same tax year</v-btn>
        </v-col>
        <v-col cols="6">
          <h4>Create a {{ selectedRowData.taxYear }} tax record
            based on highlighted record</h4>
        </v-col>
        <v-col cols="6">
          <v-btn class="input-text-size" text color="blue darken-1"
           @click="onClick('nxtTaxYear')" :disabled="enableNextTaxYear">
            Copy to next tax year</v-btn>
        </v-col>
        <v-col cols="6">
          <h4>Create a {{ selectedRowData.taxYear + 1 }} tax record based on highlighted record</h4>
        </v-col>
      </v-row>
    </template>
  </CRUDDialog>
</template>

<script>
import {
  mapMutations, mapGetters, mapState,
} from 'vuex';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import { getTaxYearStatus } from '../../common-utils/tax-common.util';

export default {
  name: 'CreateOmitDialog',
  props: {
    baseCrudKey: {
      type: String,
      default: 'createOmit',
    },
    baseCrudKeyOfMainComponent: {
      type: String,
      default: 'ownerTransactionList',
    },
    baseCrudKeyForCreateSA: {
      type: String,
      default: 'createSA',
    },
    baseCrudKeyForCreateNewOmitForm: {
      type: String,
      default: 'createNewOmitForm',
    },
    selectedRowData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
    };
  },
  components: {
    CRUDDialog,
  },
  computed: {
    ...mapGetters('base/crud', [
      'isVisible',
      'selectedTab',
      'criteria',
      'item',
      'items',
    ]),
    ...mapState({
      isItOmitOrSa: (state) => state.tax.taxFee.isItOmitOrSa,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,

    }),
    selectOwnerTab: {
      get() {
        return this.selectedTab(this.baseCrudKeyForCreateNewOmitForm);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKeyForCreateNewOmitForm, value]);
      },
    },
    getCurrentTaxYear() {
      const getTaxYearStats = getTaxYearStatus();
      return getTaxYearStats.currentTax;
    },
    enableNextTaxYear() {
      // const getTaxYearStats = getTaxYearStatus();
      // return getTaxYearStats.currentTax <= this.selectedRowData.taxYear;
      if (this.latestTaxYear < this.selectedRowData.taxYear + 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setSelectedTab',
      'setItem',
      'setItems',
    ]),
    ...mapMutations('tax/taxFee', [
      'setIsItOmitOrSa',
    ]),
    onCreteOmit() {
      if (!this.isItOmitOrSa) this.setIsItOmitOrSa(true);
      // add only owner details from selected row data
      const objForEditItem = {
        taxId: null,
        taxYear: null,
        baseId: null,
        schoolDistrict: this.selectedRowData.schoolDistrict || '',
        // name1: this.selectedRowData.name1 || '',
        // name2: this.selectedRowData.name2 || '',
        // inCareOf1: this.selectedRowData.inCareOf1 || '',
        // inCareOf2: this.selectedRowData.inCareOf2 || '',
        // address1: this.selectedRowData.address1 || '',
        // address2: this.selectedRowData.address2 || '',
        // address3: this.selectedRowData.address3 || '',
        // address4: this.selectedRowData.address4 || '',
        // city: this.selectedRowData.city || '',
        // state: this.selectedRowData.state || '',
        // zip: this.selectedRowData.zip || null,
        // country: this.selectedRowData.country || '',
        // emailAddess: this.selectedRowData.emailAddess || '',
        // primaryPhone: this.selectedRowData.primaryPhone || null,
      };
      this.setItem([this.baseCrudKeyForCreateNewOmitForm, objForEditItem]);
      this.$emit('callBackForNewCreateOmit', this.selectedRowData, 'o', this.baseCrudKeyForCreateNewOmitForm, 'omittedProperties', true);
    },
    onClick(whichOne) {
      this.$emit('callBackForDialogOpen', whichOne);
    },
  },
};
</script>
